<template>
	<div class="pages">
		<section class="data-cont">
			<h3 class="fx fx-x-between fx-y-center">
				<div class="fx">
					<p>交易数据累计</p>
					<div class="question-cont">
						<i class="icon-question "></i>
						<div class="question-explain">
							<h5>交易金额</h5>
							<p>微商城支付成功且未退款的金额</p>
							<h5>交易笔数</h5>
							<p>微商城支付成功且未退款笔数</p>
							<h5>日期检索</h5>
							<p>年-月-日 00：00:00 --年-月-日 23:59:59</p>
						</div>
					</div>
				</div>
				<div>
					<div class="fx fx-wrap m-l-10">
						<el-date-picker
						  v-model="stasticDate"
					      type="daterange"
					      align="left"
					      format="yyyy-MM-dd"
					      placeholder="选择日期范围(默认全部)"
					      :picker-options="pickerOptions"
					      @change="handleStatisticsInfo">
					    </el-date-picker>
					</div>
				</div>
			</h3>
			<div class="member-cont">
				<div class="member-data">
					<ul class="fx text-center">
						<li class="fx-fill">
							<strong>{{info.pay_fee | filterMoney}}<em>元</em></strong>
							<p>交易金额</p>
						</li>
						<li class="fx-fill">
							<strong>{{info.pay_count}}<em>笔</em></strong>
							<p>交易笔数</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="data-cont">
			<h3 class="fx fx-x-between fx-y-center">
				<div class="fx fx-y-center">
					<div class="fx">
						<p>交易趋势</p>
						<div class="question-cont">
							<i class="icon-question "></i>
							<div class="question-explain">
								<h5>交易金额</h5>
								<p>交易金额趋势图分析</p>
								<h5>交易笔数</h5>
								<p>交易笔数趋势图分析</p>
							</div>
						</div>
					</div>
				</div>
				<z-daybar :on-click="handleMallOrderStisticItem"></z-daybar>
			</h3>
			<div class="m-t-20" id="vmallDataCube" style="width:auto;height: 400px;"></div>
		</section>
	</div>
</template>

<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'OrderStatistics',
		components: {},
		data() {
			return {
				vmallChart:null,
				trendOption: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['交易金额','交易笔数']
					},
					grid: {
						left: '3%',
						right: '4%',
						//				        bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: []
					},
					yAxis: {
						type: 'value'
					},
					series: [ {
							name: '交易金额',
							type: 'line',
							stack: '数量',
							data: []
						},
						{
							name: '交易笔数',
							type: 'line',
							stack: '金额',
							data: []
						}
					]
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近15天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				stasticDate:[null,null],
				params: {
					startDate: null,
					endDate: null
				},
				type: 7
			}
		},
		computed: {
			...mapState({
				info: state => state.vmall.statistics
			})
		},
		mounted() {
				this.handleStatisticsInfo();
				this.handleMallOrderStisticItem(7)
			this.initEcharts()
			window.onresize = () =>{
				this.vmallChart.resize();
			}
		},
		/*
		 * 事件处理
		 */
		methods: {
			initEcharts() {
				//初始化图表
				this.vmallChart = this.$echartsInit('vmallDataCube', {
					width: 'auto',
					height: 400
				})
				this.vmallChart.setOption(this.trendOption);
			},

			//获取订单统计数据
			handleStatisticsInfo() {
				this.params = {
					startDate: this.stasticDate[0],
					endDate: this.stasticDate[1]
				}
				this.getOrderStatisticsInfo(this.params)
			},
			//获取数据走势数据
			async handleMallOrderStisticItem(day){
				const data = await this.mallOrderStisticItem({day})
				const dates = [],
						counts = [],
						totals = []
				data.map((item,index)=>{
					dates.push(item.day)
					counts.push(this.$filterMoney(item.count))
					totals.push(item.total)
				})
				
				this.vmallChart.setOption({
					xAxis: {
						data:dates
					},
					series: [{
							data: counts
						},
						{
							data: totals
						}
					]
				})
			},

			...mapActions(['getOrderStatisticsInfo', 'mallOrderStisticItem']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.data-cont {
		border-bottom: none;
	}
	.pages {
		min-width: px-em(1400px);
		.chart-cont {
			border-top: none;
			ol li {
				+li {
					border-left: none;
				}
				transition: all 0.2s ease;
				padding: px-em(10px) px-em(20px);
				cursor: pointer;
				border: 1px solid $color-border;
				&:hover {
					background: rgba(0, 0, 0, 0.1);
				}
				&.active {
					background: rgba(0, 0, 0, 0.1);
				}
			}
		}
		.member-cont {
			li {
				width: 33.33%;
			}
		}
		.member-key-cont {
			li {
				width: 25%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// OrderStatistics.vue?f1fc8b20